import { foundation } from '../../ui';
import { semantic as sem } from '../../ui/theme/semanticTokens';

/** All skeleton chrome uses white cards — never dark/colored UI mimics. */
export const SKELETON_SURFACE = foundation.color.neutral.surface;

/**
 * KAN-1151: a PDF page is paper — white in BOTH themes (the real canvas is white even in
 * Graphite), so the PDF skeleton's page never flashes dark before crossfading to white.
 * The area AROUND the page keeps SKELETON_SURFACE (themed). Only PdfPreviewSkeleton uses it.
 */
export const SKELETON_PAPER = sem.tint.logoPlate;

/** Mirrors the refreshed DashboardWidgetCard material (widget-refresh 2026) —
    skeleton cards must match what they become or first paint reads as a jump. */
export const skeletonCardShell = {
  background: SKELETON_SURFACE,
  borderRadius: foundation.radii.lg,
  border: `1px solid ${sem.edge.hair06}`,
  boxShadow: foundation.shadow.widget,
  boxSizing: 'border-box',
};
